import React from "react";
import { setDocData } from "../../Firebase/Firebase.utils";
import { useSelector } from "react-redux";
import { useState } from "react";
import { toast } from "react-hot-toast";
import InputBox from "../../components/InputBox";

function EditContactForm({ handleEditMode, contact }) {
  const [formData, setFormData] = useState(contact);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const currentUser = useSelector((state) => state.userObject);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    //check if phone or email is not empty
    if (!formData.contactPhone && !formData.contactEmail) {
      toast.error("Please enter either phone or email");
      return;
    }
    const docObject = {
      ...formData,
      updatedAt: new Date().toISOString(),
      lastUpdatedBy: currentUser.email,
    };
    setIsSubmitting(true);
    await setDocData("contacts", contact.id, docObject);
    setIsSubmitting(false);
    toast.success("Contact udpated successfully");
    handleEditMode();
  };
  return (
    <div className="small-form">
      <button className="close-button" onClick={handleEditMode}>
        Close
      </button>
      <div className="header pt-8">Edit Contact</div>
      <form className="flex flex-col gap-2" onSubmit={handleSubmit}>
        <InputBox
          name="contactName"
          label="Contact Name"
          type="text"
          value={formData.contactName}
          placeholder={"Enter contact name"}
          onChange={handleChange}
          required
        />
        <InputBox
          name="contactPosition"
          label="Position"
          type="text"
          value={formData.contactPosition}
          placeholder={"Enter contact position"}
          onChange={handleChange}
          required
        />
        <InputBox
          name="contactEmail"
          label="Email"
          type="email"
          value={formData.contactEmail}
          placeholder={"Enter contact email"}
          onChange={handleChange}
        />
        <InputBox
          name="contactPhone"
          label="Phone"
          type="text"
          value={formData.contactPhone}
          placeholder={"Enter contact phone"}
          onChange={handleChange}
        />
        <button className="blue-button" type="submit">
          {isSubmitting ? "Updating contact..." : "Update Contact"}
        </button>
      </form>
    </div>
  );
}

export default EditContactForm;
